import React, {useEffect, useState, useRef} from "react";
import {getClassDailyStudyStage} from "../../../network/Endpoint";
import {checkToast, messageToast} from "../../../components/Toast";
import StudentStats from "../components/studentStats/StudentStats";
import LessonNavigation from "../components/lessonNavigation/LessonNavigation";
import FilterLayerDaily from "../components/filter/FilterLayerDaily";
import LearningResultsTableDaily from "../components/learningResults/LearningResultsTableDaily";
import {useSearchParams, useNavigate} from "react-router-dom";
import {useRecoilState, useRecoilValue} from "recoil";
import {dailyStageLevelState, dailyStageState, lessonClassState} from "../../../recoil/lesson/lessonState";
import SideMenu from "../../../components/SideMenu";
import {mainClassState} from "../../../recoil/classes/classesState";

const DailyStagePage = () => {
    const [classId, setClassId] = useRecoilState(lessonClassState);
    const [stageId, setStageId] = useRecoilState(dailyStageState);
    const [level, setLevel] = useRecoilState(dailyStageLevelState);
    const mainClass = useRecoilValue(mainClassState);
    const navigate = useNavigate();
    const isInitialMount = useRef(true);

    const [searchParams] = useSearchParams();
    const [excellentStudentList, setExcellentStudentList] = useState([]); // List<ExcellentStudentDto>
    const [inCompletedStudentList, setInCompletedStudentList] = useState([]); // List<String>
    const [classStageStudentList, setClassStageStudentList] = useState([]); // List<ClassStageStudentDto>
    const [filterInfoList, setFilterInfoList] = useState([]); // List<FilterInfoDto>
    const [activeFilter, setActiveFilter] = useState();
    const [chapterSeq, setChapterSeq] = useState(null); // Integer
    const [stageName, setStageName] = useState(""); // String

    useEffect(() => {
        if(searchParams.size>0){
            let classIdParam;
            if(searchParams.get("classId")!=null){
                classIdParam = searchParams.get("classId");
                setClassId(classIdParam);
            }else{
                classIdParam = classId;
            }
            let stageIdParam;
            if(searchParams.get("stageId")!=null){
                stageIdParam = searchParams.get("stageId");
                setStageId(stageIdParam);
            }else{
                stageIdParam = stageId;
            }
            let levelParam;
            if(searchParams.get("level")!=null){
                levelParam = searchParams.get("level");
                setLevel(levelParam);
            }else{
                levelParam = level;
            }


            fetchGetStageResultParam(classIdParam, stageIdParam).then();

            window.history.replaceState(null, "", "/page/classDailyStage"); // 주소창에서 경로를 숨김
        }
    }, [searchParams]);


    const fetchGetStageResultParam = async (classId, stageId) => {
        try {
            const body = { classId: classId, stageId: stageId };
            const res = await getClassDailyStudyStage(body);
            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                setChapterSeq(res.data.data.chapterSeq);
                setStageName(res.data.data.stageName);
                setExcellentStudentList(res.data.data.excellentStudentList);
                setInCompletedStudentList(res.data.data.inCompletedStudentList);

                setClassStageStudentList(res.data.data.classStageStudentList);
                setFilterInfoList(res.data.data.filterInfoList);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };


    const fetchGetStageResult = async (reloadCheck) => {
        try {
            const body = { classId: classId, stageId: stageId };
            const res = await getClassDailyStudyStage(body);
            const statusCode = res.data.status.code;

            if (statusCode === 'Success') {
                setChapterSeq(res.data.data.chapterSeq);
                setStageName(res.data.data.stageName);
                setExcellentStudentList(res.data.data.excellentStudentList);
                setInCompletedStudentList(res.data.data.inCompletedStudentList);
                if(reloadCheck){
                    if(JSON.stringify(classStageStudentList)===JSON.stringify(res.data.data.classStageStudentList)){
                        checkToast("변경된 데이터가 없습니다.")
                    }else{
                        let description = res.data.data.level+"레벨 "+res.data.data.chapterSeq+"단원 / " + res.data.data.stageName;
                        messageToast({message : "데이터가 갱신되었습니다.", description : description});
                    }
                }
                setClassStageStudentList(res.data.data.classStageStudentList);
                setFilterInfoList(res.data.data.filterInfoList);
            }
        } catch (error) {
            alert(`[${error.message}]\n 학생 정보 로드 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.`);
        }
    };


    useEffect(() => {
        if(searchParams.size===0){
            fetchGetStageResultParam(classId, stageId).then();
        }
    }, []);


    const reloadPage = () =>{
        fetchGetStageResult(true);
    };

    useEffect(() => {
        // 첫 번째 마운트가 아닌 경우에만 페이지 이동
        if (!isInitialMount.current) {
            navigate("/page/classDaily");
        } else {
            // 첫 번째 마운트 이후 플래그 변경
            isInitialMount.current = false;
        }
    }, [mainClass, navigate]);

    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8] relative">
            {/* Main content section */}
            <div className="flex flex-row items-center justify-between gap-2 w-[1044px] mt-8">
                <div
                    className="flex flex-col justify-center px-6 pt-5 pb-6 max-w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] w-[1044px] max-md:px-5 max-md:mt-10">
                    {/* Header content */}
                    <LessonNavigation
                        reload={reloadPage}
                        level={level}
                        chapter={chapterSeq}
                        stageName={stageName}
                    />
                </div>
            </div>
            {/* Statistics Grid */}
            <div>
                <StudentStats
                    excellentStudentList={excellentStudentList}
                    inCompletedStudentList={inCompletedStudentList}
                    filterInfoList={filterInfoList}
                    classStageStudentList={classStageStudentList}
                />

            </div>
            {/* Statistics Grid */}
            <div>
                <FilterLayerDaily
                    filterInfoList={filterInfoList}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                />

            </div>
            {/* classResults Result Section */}
            <div>
                <LearningResultsTableDaily
                    classStageStudentList={classStageStudentList}
                    activeFilter={activeFilter}
                />
            </div>
            <SideMenu></SideMenu>
        </div>

    );
}

export default DailyStagePage;